import axios from 'axios';
let cid = 1;
function buildParams(params) {
    var result = [];

    for (var i in params) {
        let value = params[i];
        value = typeof value === 'object' ? JSON.stringify(value) : value
        result.push(encodeURIComponent(i) + '=' + encodeURIComponent(value));
    }

    return result.join('&');
}

export default (config) => {
   /* 
    if (typeof document === 'undefined') {
        return undefined;
    }
    */
    return new Promise(function (resolve, reject) {
        const callbackParamName = config.callbackParamName || 'callback';
        //add callback if missing
        if (!(callbackParamName in config.params)) {
            config.params[callbackParamName] = `axiosJSONPCallBack${cid++}`;
        }
        if (typeof document === 'undefined' || typeof document.createElement === 'undefined') {
            //if API being called from the server then just make a normal api call and strip out the jsonp stuff
            axios({ ...config, adapter: undefined }).then(({ status, data}) => {
                    if (status === 200 && data && data !== '') {
                        try {
                            const callbackFunc = config.params[callbackParamName];
                            const responseJson = JSON.parse(data.replace(new RegExp(`^${callbackFunc}\\(|\\)\\;?|$`, 'gs'), ''));
                            resolve({
                                status: 200,
                                data: responseJson
                            });
                        } catch (e) {
                            reject(e)
                        }
                    } else {
                        return reject(status)
                    }
            }).catch(e => {
                reject(e);
            });
        } else {
            var script = document.createElement('script');
            var src = `${config.baseURL}${config.url}`;

            if (config.params) {
                var params = buildParams(config.params);

                if (params) {
                    src += (src.indexOf('?') >= 0 ? '&' : '?') + params;
                }
            }

            script.async = true;

            function remove() {
                if (script) {
                    script.onload = script.onreadystatechange = script.onerror = null;

                    if (script.parentNode) {
                        script.parentNode.removeChild(script);
                    }

                    script = null;
                }
            }

            var jsonp = config.params[callbackParamName];
            var old = window[jsonp];
            var isAbort = false;

            window[jsonp] = function(responseData) {
                window[jsonp] = old;

                if (isAbort) {
                    return;
                }
                
                var response = {
                    data: responseData,
                    status: 200
                }

                resolve(response);
            };

            script.onload = script.onreadystatechange = function() {
                if (!script.readyState || /loaded|complete/.test(script.readyState)) {
                    remove();
                }
            };

            script.onerror = function() {
                remove();

                reject(new Error('Network Error'));
            };

            if (config.cancelToken) {
                config.cancelToken.promise.then(function(cancel) {
                    if (!script) {
                        return;
                    }

                    isAbort = true;

                    reject(cancel);
                });
            }        

            script.src = src;

            document.head.appendChild(script);
        }
    });
};